<template>
<div class="about columns is-4">
    <div class="column "></div>
    <div class="column is-three-fifths">
        <div class="container has-text-center" style="margin-left:0;margin-right:0;padding-left:4rem;padding-right:4rem;text-align:center;font-size:20px">When Dean Cycon started Dean’s Beans in 1993, he set out to prove that a for-profit business could create meaningful change through ethical business practices rooted in respect for the earth, the farmer, our co-workers and the consumer.</div>
        <div class="is-flex is-horizontal-center" style="padding-bottom:2rem;padding-top:2rem"><img src="@/assets/images/about00.png"></div>
        <p style="text-align:center;">Dean spent over a decade as an indigenous rights and environmental lawyer before bringing those skills to the coffee industry by co-founding Coffee Kids, the coffee industry’s first non-profit development organization, in 1988. Yet after designing and managing the development arm of Coffee Kids for five years, Dean decided that charity wasn’t enough – until businesses changed their fundamental operating principles there would be no meaningful impact on the lives of the farmers. He founded Dean’s Beans Organic Coffee in 1993 with the mission of using specialty coffee as a vehicle for positive social, economic and ecological change in the Coffeelands.</p>
        <p style="text-align:center;padding-bottom:4rem;padding-top:2rem"><strong>We brew great coffee and create real change through:</strong></p>
        <about-detail
            title="Long Term Relationships"
            body="We directly partner with many of our coffee farming cooperatives, and have since day one!  Our relationships with Prodecoop (Nicaragua), Cosurca (Colombia) and KKGO (Sumatra) are as long-lasting, rich and meaningful as their coffee. This is one of the greatest differences to how we do Fair Trade business - our farmers can count on us year after year. We commit to the farms and partner on projects that make significant positive changes for their communities."
            image="images/about01.png"
            style="margin-bottom:3rem"
        />
        <about-detail
            title="Organic, Shade-grown and Bird Friendly Coffee"
            body="Habitat degradation is a big problem in the Coffeelands, since clear cutting and mono-culture have become prevalent.  We purchase only organic, shade-grown coffees that support healthy environments for growers and provide the erosion control necessary for ecosystems to flourish. Shade-grown coffee also provides critical habitat for migratory birds (many from our own backyards!) and other species that winter in the Coffeelands. A few of our partners have been officially certified as “Bird Friendly” by the Smithsonian Migratory Bird Center. "
            image="images/about02.png"
            style="margin-bottom:3rem"
        />
        <about-detail
            title="Direct Farm-to-Roaster Trading"
            body="Each year we talk to the farm coops and agree on a fair price for a container of coffee. Our farmers process the coffee, grade, mill, bag and export directly to us. That means the last person to see the coffee in its home country is the farmer who carried the bag into the container. The next person to see the coffee is at Dean’s Beans, when we open the container. That’s direct trade!"
            image="images/about03.png"
            style="margin-bottom:3rem"
        />
        <about-detail
            title="Solar-Powered Net-Zero Energy Roasting Facility "
            body="Dean’s Beans was one of the first companies in Massachusetts to install solar panels back in 2006. We keep investing in renewable energies to support environmental stewardship and energy independence. Today, we get up to 79% of our electricity from the sun! Plus, with all the reforestation we do in the Coffeelands, Dean’s Beans has a net-zero carbon footprint!"
            image="images/about04.png"
            style="margin-bottom:3rem"
        />
        <about-detail
            title="People-Centered Development Programs"
            body="We are committed to meaningful sustainable projects that each farming community designs. People-centered development focuses on the needs expressed by local communities, like clean water, health care, education, and income generation.  At the end of the day, the community-led empowerment experienced by the farmers we work with is our greatest achievement."
            image="images/about05.png"
            style="margin-bottom:3rem"
        />
    </div>
    <div class="column "></div>
    
</div>


</template>
<script>
import AboutDetail from '@/components/AboutDetail'

export default {
  name: 'About',
  components: {
    'about-detail': AboutDetail
  },
}
</script>
<style scoped>
.is-horizontal-center {
  justify-content: center;
}
</style>